var React = require('react');

function Video (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M15,0 C6.728,0 0,6.728 0,15 C0,23.272 6.728,30 15,30 C23.272,30 30,23.272 30,15 C30,6.728 23.272,0 15,0 Z M15,2 C22.1913333,2 28,7.80866667 28,15 C28,22.1913333 22.1913333,28 15,28 C7.80866667,28 2,22.1913333 2,15 C2,7.80866667 7.80866667,2 15,2 Z","id":"Fill-1","key":0}),React.createElement("polygon",{"id":"Path","points":"11 8.66666667 11 21.3333333 22.3333333 15","key":1})]);
}

Video.defaultProps = {"viewBox":"0 0 30 30","version":"1.1"};

module.exports = Video;

Video.default = Video;
